import { Box, Typography, IconButton } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { getResponsiveHeight, getResponsiveSize } from "../utils/responsive";
import globalStyles from "../global";
import Footer from "../components/HomeComponent/Footer";
import CardComponent from "../components/EventComponent/CardComponent";
import { useTranslation } from "react-i18next";
import News from "../components/globalCountries/countryhomepagescomponent/News";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import EventBanner from "../components/HomeComponent/EventBanner";
import { useNavigate } from "react-router-dom";

const CARD_GAP = 24;

const Event = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const upcomingSliderRef = useRef(null);
  const pastSliderRef = useRef(null);

  const [upcomingSliderPosition, setUpcomingSliderPosition] = useState(0);
  const [pastSliderPosition, setPastSliderPosition] = useState(0);
  const [visibleCards, setVisibleCards] = useState(getVisibleCards());

  useEffect(() => {
    const handleResize = () => {
      setVisibleCards(getVisibleCards());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const upcomingEvents = [
    {
      title: "Meet the Founder of Asia's largest laundry chain in SRI LANKA",
      date: "coming soon",
      time: "coming soon",
      location: "sri lanka",
      description:
        "Benefit from our solid online and offline presence, boosting the enviable Google rating of 4.5/5.",
      image: "dohaImage.png",
      regButton: true,
      buttonUrl: "/upcoming-event",
    },
  ];

  const pastEvents = [
    {
      title: "Meet the Founder of Asia's largest laundry chain in Doha",
      date: "11th February 2025",
      time: "10:00 AM - 5:00 PM",
      location: "JW Marriott, Doha",
      description:
        "Benefit from our solid online and offline presence, boasting an enviable Google rating of 4.5/5.",
      image: "dohaImage.png",
      regButton: false,
      buttonUrl: "/highlights/doha",
    },
    {
      title: "Meet the Founder of Asia's largest laundry chain in Abu Dhabi",
      date: "13th February 2025",
      time: "10:00 AM - 5:00 PM",
      location: "Le Royal Meridien, Abu Dhabi",
      description:
        "Benefit from our solid online and offline presence, boasting an enviable Google rating of 4.5/5.",
      image: "abudhabi.png",
      regButton: false,
      buttonUrl: "/highlights/abudhabi",
    },
    {
      title: "Meet the Founder of Asia's largest laundry chain in Abu Dhabi",
      date: "15th February 2025",
      time: "10:00 AM - 5:00 PM",
      location: "Le Royal Meridian, Abudhabi",
      description:
        "Benefit from our solid online and offline presence, boasting an enviable Google rating of 4.5/5.",
      image: "abudhabi.png",
      regButton: false,
      buttonUrl: "/highlights/dubai",
    },
    {
      title: "Meet the Founder of Asia's largest laundry chain in Sri Lanka",
      date: "26th & 27th April 2025",
      time: "11:00 AM - 6:00 PM",
      location: "Sri Lanka",
      description:
        "Benefit from our solid online and offline presence, boasting an enviable Google rating of 4.5/5.",
      image: "dohaImage.png",
      regButton: false,
      buttonUrl: "/highlights/srilanka",
    },
    {
      title: "Meet the Founder of Asia's largest laundry chain in Thailand",
      date: "26th & 27th April 2025",
      time: "11:00 AM - 6:00 PM",
      location: "Bangkok",
      description:
        "Benefit from our solid online and offline presence, boasting an enviable Google rating of 4.5/5.",
      image: "dohaImage.png",
      regButton: false,
      buttonUrl: "/highlights/srilanka",
    },
  ];

  const slideNext = (
    sliderRef,
    events,
    currentPosition,
    setPosition,
    visibleCardsCount
  ) => {
    const slider = sliderRef.current;
    if (!slider) return;
    const card = slider.querySelector(".event-card");
    if (!card) return;
    const cardWidth = card.offsetWidth;
    const slideWidth = cardWidth + CARD_GAP;
    const maxPosition = -(slideWidth * (events.length - visibleCardsCount));
    const newPosition = Math.max(currentPosition - slideWidth, maxPosition);
    setPosition(newPosition);
    slider.style.transform = `translateX(${newPosition}px)`;
  };

  const slidePrev = (sliderRef, currentPosition, setPosition) => {
    const slider = sliderRef.current;
    if (!slider) return;
    const card = slider.querySelector(".event-card");
    if (!card) return;
    const cardWidth = card.offsetWidth;
    const slideWidth = cardWidth + CARD_GAP;
    const newPosition = Math.min(currentPosition + slideWidth, 0);
    setPosition(newPosition);
    slider.style.transform = `translateX(${newPosition}px)`;
  };

  function getVisibleCards() {
    if (typeof window === "undefined") return 1;
    const width = window.innerWidth;
    if (width >= 1200) return 3;
    if (width >= 600) return 2;
    return 1;
  }

  const shouldShowNavigation = (events) => {
    return events.length > visibleCards;
  };

  return (
    <Box>
      <EventBanner />

      {/* UPCOMING EVENTS SLIDER */}
      <Box sx={styles.section}>
        <Box sx={styles.sectionHeader}>
          <Box>
            {" "}
            <Typography
              variant="h1_gothic"
              sx={{
                fontSize: { xs: "24px", sm: "38px", md: "40px" },
              }}
            >
              UPCOMING EVENTS
            </Typography>
          </Box>
          {shouldShowNavigation(upcomingEvents) && (
            <Box sx={styles.navigationButtons}>
              <IconButton
                onClick={() =>
                  slidePrev(
                    upcomingSliderRef,
                    upcomingSliderPosition,
                    setUpcomingSliderPosition
                  )
                }
                sx={styles.navButton}
                disabled={upcomingSliderPosition >= 0}
              >
                <ArrowBackIosIcon />
              </IconButton>
              <IconButton
                onClick={() =>
                  slideNext(
                    upcomingSliderRef,
                    upcomingEvents,
                    upcomingSliderPosition,
                    setUpcomingSliderPosition,
                    visibleCards
                  )
                }
                sx={styles.navButton}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </Box>
          )}
        </Box>
        <Box sx={styles.text2}>{t("event.upcomingEventsDescription")}</Box>

        <Box
          sx={{
            ...styles.sliderContainer,
            height: "600px",
          }}
        >
          <Box ref={upcomingSliderRef} sx={styles.slider}>
            {upcomingEvents.map((event, idx) => (
              <Box
                key={idx}
                className="event-card"
                sx={slideCardStyles(visibleCards)}
              >
                <CardComponent {...event} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      {/* PAST EVENTS SLIDER */}
      <Box sx={styles.section}>
        <Box sx={styles.sectionHeader}>
          <Box sx={styles.text1}>
            <Typography
              variant="h1_gothic"
              sx={{
                fontSize: { xs: "24px", sm: "38px", md: "40px" },
              }}
            >
              PAST EVENTS
            </Typography>
          </Box>
          {shouldShowNavigation(pastEvents) && (
            <Box sx={styles.navigationButtons}>
              <IconButton
                onClick={() =>
                  slidePrev(
                    pastSliderRef,
                    pastSliderPosition,
                    setPastSliderPosition
                  )
                }
                sx={styles.navButton}
                disabled={pastSliderPosition >= 0}
              >
                <ArrowBackIosIcon />
              </IconButton>
              <IconButton
                onClick={() =>
                  slideNext(
                    pastSliderRef,
                    pastEvents,
                    pastSliderPosition,
                    setPastSliderPosition,
                    visibleCards
                  )
                }
                sx={styles.navButton}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </Box>
          )}
        </Box>
        <Box sx={styles.text2}>{t("event.pastEventsDescription")}</Box>

        <Box sx={{ ...styles.sliderContainer, height: "600px" }}>
          <Box ref={pastSliderRef} sx={styles.slider}>
            {pastEvents.map((event, idx) => (
              <Box
                key={idx}
                className="event-card"
                sx={slideCardStyles(visibleCards)}
                onClick={() => {
                  // Use navigate with route param or state
                  navigate(`/past-event/${idx}`, { state: { event } });
                }}
                style={{ cursor: "pointer" }}
              >
                <CardComponent {...event} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      {/* HIGHLIGHTS SECTION */}
      <Box
        sx={{
          backgroundImage: `url(${process.env.REACT_APP_IMAGE_BASE_URL}eventsHighlightsBanner.svg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          // height: "650px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "white",
          // mt: 4,
          py: 8,
          mb: 4,
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          sx={{ ...styles.text1, textTransform: "uppercase" }}
        >
          Highlights from Previous Events
        </Typography>
        <Typography variant="body1" maxWidth="700px" sx={styles.text2}>
          Own a UClean franchise and become a leader in the global laundry
          industry. Our flexible business models and support system ensure a
          seamless start and profitable growth.
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Box
            component="img"
            src={`${process.env.REACT_APP_IMAGE_BASE_URL}highlight.svg`}
            alt="Event Highlight Icon"
            sx={{
              width: "100%",
              height: "auto",
            }}
          />
          <Typography variant="caption" sx={{ ...styles.text2, mt: 1 }}>
            Laundry Business Seminar in Dubai &nbsp; | &nbsp; Radisson Blu
            Hotel, Dubai Waterfront
          </Typography>
        </Box>
      </Box>
      <News />
      <Box sx={{ height: { sm: "80px", xs: "20px" } }} />
      <Footer />
    </Box>
  );
};

// Responsive card style: default size except on small screens
function slideCardStyles(visibleCards) {
  return {
    minWidth:
      visibleCards === 3
        ? "calc(33.333% - 16px)"
        : visibleCards === 2
        ? "calc(50% - 12px)"
        : "100%",
    flexShrink: 0,
    "@media (max-width:600px)": {
      minWidth: "90vw",
      maxWidth: "90vw",
      px: 0.5,
    },
  };
}

const styles = {
  section: {
    width: "100%",
    maxWidth: "1200px",
    pl: "5px",
    margin: "48px auto 0 auto",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 2,
  },
  navigationButtons: {
    display: "flex",
    gap: 1,
  },
  navButton: {
    backgroundColor: globalStyles.colors.army_green,
    color: "white",
    width: 40,
    height: 40,
    "&:hover": {
      backgroundColor: globalStyles.colors.army_green,
      opacity: 0.8,
    },
    "&:disabled": {
      backgroundColor: "#ccc",
      color: "#666",
    },
  },
  text1: {
    fontFamily: "AllRoundGothicBold, 'Poppins', sans-serif",
    fontWeight: 600,
    color: globalStyles.colors.army_green,
    marginTop: getResponsiveHeight(2),
  },
  text2: {
    fontFamily: "'Poppins', sans-serif",
    color: globalStyles.colors.uclean_medium_gray,
    marginBottom: getResponsiveHeight(3),
  },
  sliderContainer: {
    overflow: "hidden",
    width: {
      xs: getResponsiveSize(400),
      sm: getResponsiveSize(700),
      md: getResponsiveSize(1720),
    },
    mt: 2,
  },
  slider: {
    display: "flex",
    gap: `${CARD_GAP}px`,
    transition: "transform 0.3s ease-in-out",
    width: "fit-content",
  },
  heading: {
    fontFamily: "AllRoundGothicBold, 'Poppins', sans-serif",
    fontWeight: 700,

    color: globalStyles.colors.army_green,
    letterSpacing: "0.5px",
    mb: 1,
    mt: 3,
    textTransform: "uppercase",
  },
  subheading: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 400,

    color: "#6B6B6B",
    mb: 3,
    mt: 0,
  },
};

export default Event;
